export const ArticleStatus = {

    PUBLISHED:"منتشر شده",
    DRAFT:"پیشنویس",
    WAIT_FOR_REVIEW:"در انتظار بازبینی",
    null:"نامشخص"
}
